import {
  Alert,
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@alice-financial/pretext-ui'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import * as React from 'react'
import { LaunchDateInput } from '../../homepage/LaunchDateInput'
import { useOrg } from '../../organization/useOrg'
import { dateFormat, dateStringFormat } from '@alice-financial/alice-sdk'

export const LaunchDateStepTitle = 'Launch Date'

export const LaunchDateDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Set when employees can start enrolling
  </Typography>
)

// Wrapper component that uses the core launch date components
export const LaunchDateComponent = () => {
  const org = useOrg()

  if (!org) return null

  const todayIso = dateFormat.isoDate(new Date())
  const isToday = org.launchDate === todayIso
  const isFuture = org.launchDate && org.launchDate > todayIso

  return (
    <>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Once you&apos;ve completed all setup steps, you&apos;re ready to launch Alice. The launch date
        determines when your employees will receive enrollment invitations.
      </Typography>
      {isFuture && org.launchDate && (
        <Alert severity="info">
          <Typography variant="body2" color="text.secondary" fontWeight="bold">
            Launching {dateFormat.medium(dateStringFormat.dateFromDateString(org.launchDate))}
          </Typography>
        </Alert>
      )}
      <Grid container flexWrap="nowrap" alignItems="center">
        <Grid flex={1}>
          <Typography variant="body2">
            {!org.launchDate && 'Choose when your employees should receive enrollment invitations.'}
            {isToday && 'Your employees can now start enrolling.'}
            {org.launchDate && isFuture && (
              <>
                Employees will receive enrollment invitations starting on{' '}
                {dateFormat.short(dateStringFormat.dateFromDateString(org.launchDate))}. You may choose a
                different date any time before then.
              </>
            )}
          </Typography>
        </Grid>
        <LaunchDateInput org={org} />
      </Grid>
    </>
  )
}

export const LaunchDateInstructions = () => (
  <Box>
    <Typography variant="h4" gutterBottom>
      Set Launch Date
    </Typography>

    <Typography variant="body2" color="text.secondary" gutterBottom>
      If we&apos;re not able to complete other requirements by your chosen launch date, we&apos;ll postpone
      launch and contact you to help complete other requirements.
    </Typography>

    <Typography variant="subtitle1" fontWeight="bold">
      Key Info
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="The launch date won't prevent employees from enrolling early, if all onboarding requirements are complete" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="We will only email employees who are listed in payroll" />
      </ListItem>
    </List>
  </Box>
)
